"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportStatus = exports.FAIL_ZIP = exports.FAIL_TAKE_DETAIL_DUMP = exports.FAIL_TAKE_CONFIG_DUMP = exports.FAIL_SURFACE_DEPLOYMENT = exports.FAIL_SURFACE_ENV = exports.FAIL_SURFACE_CODE = exports.FAIL_ENGINE_DEPLOYMENT = exports.FAIL_ENGINE_ENV = exports.FAIL_ENGINE_CODE = exports.FAIL_CREATE_HTML = exports.FAIL_PROJECT_SETTING = exports.DOWNLOADED = exports.EXPORTED = exports.CREATED = void 0;
exports.CREATED = "CREATED";
exports.EXPORTED = "EXPORTED";
exports.DOWNLOADED = "DOWNLOADED";
exports.FAIL_PROJECT_SETTING = "FAILED_PROJECT_SETTING";
exports.FAIL_CREATE_HTML = "FAILED_CREATE_HTML";
exports.FAIL_ENGINE_CODE = "FAIL_ENGINE_CODE";
exports.FAIL_ENGINE_ENV = "FAIL_ENGINE_ENV";
exports.FAIL_ENGINE_DEPLOYMENT = "FAIL_ENGINE_DEPLOYMENT";
exports.FAIL_SURFACE_CODE = "FAIL_SURFACE_CODE";
exports.FAIL_SURFACE_ENV = "FAIL_SURFACE_ENV";
exports.FAIL_SURFACE_DEPLOYMENT = "FAIL_SURFACE_DEPLOYMENT";
exports.FAIL_TAKE_CONFIG_DUMP = "FAIL_TAKE_CONFIG_DUMP";
exports.FAIL_TAKE_DETAIL_DUMP = "FAIL_TAKE_DETAIL_DUMP";
exports.FAIL_ZIP = "FAIL_ZIP";
exports.exportStatus = [exports.CREATED, exports.EXPORTED, exports.DOWNLOADED, exports.FAIL_PROJECT_SETTING, exports.FAIL_CREATE_HTML, exports.FAIL_ENGINE_CODE, exports.FAIL_ENGINE_ENV, exports.FAIL_ENGINE_DEPLOYMENT, exports.FAIL_SURFACE_CODE, exports.FAIL_SURFACE_ENV, exports.FAIL_SURFACE_DEPLOYMENT, exports.FAIL_TAKE_CONFIG_DUMP, exports.FAIL_TAKE_DETAIL_DUMP, exports.FAIL_ZIP];